import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProfileService, NotificationService, BrowserStorageKeys } from '@core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationKeys, ResponseStatus, UserTypes } from 'src/app/core/enums/keys.enum';

@Component({
  selector: 'app-bio-data',
  templateUrl: './bio-data.component.html',
  styleUrls: ['./bio-data.component.less'],
  standalone: false
})
export class BioDataComponent implements OnInit {
  bioDataForm!: FormGroup;
  showForm: boolean = false;
  loading: boolean = false;
  fetching: boolean = false;
  detailsUpdated: boolean = false;
  user = JSON.parse(localStorage.getItem(BrowserStorageKeys.token)!);
  userType: string = this.user?.type;
  user_id: string = '';
  userTypes = UserTypes;
  publicUseOfEmail: boolean = false;
  biodata: any;
  emailDisplayConfirmation: string = '';

  constructor(
    private profileService: ProfileService,
    private notify: NotificationService,
    private fb: FormBuilder,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.buildBioDataForm();
    this.getBioData();
    this.emailDisplayConfirmation = this.translate.instant("PROFILE.BIO-DATA.EMAIL_DISPLAY_CONFIRMATION");
  }

  buildBioDataForm() {
    this.bioDataForm = this.fb.group({
      address: [null, Validators.compose([Validators.required])],
      address_duration: [
        null,
        Validators.compose([Validators.required, Validators.maxLength(500)]),
      ],
      former_name: [null],
      description: [null],
      email_public: [false]
    });
  }

  get address() {
    return this.bioDataForm.controls['address'].value;
  }

  get address_duration() {
    return this.bioDataForm.controls['address_duration'].value;
  }

  get former_name() {
    return this.bioDataForm.controls['former_name'].value;
  }

  get description() {
    return this.bioDataForm.controls['description'].value;
  }

  onToggleSwitch(event: any) {
    this.publicUseOfEmail = event;
  }

  getBioData() {
    this.fetching = true;
    this.profileService
      .getUser()
      .then((res: any) => {
        if (res?.status == ResponseStatus.FAILED) {
          this.showForm = false;
          this.fetching = false;
          this.notify.error("", res?.message, NotificationKeys.PROFILE);
          return;
        }
        this.fetching = false;
        this.user_id = res?.data?.id;
        this.userType = res?.data?.type;
        this.detailsUpdated = false;
        // this.showForm = true;
        if (this.userType === UserTypes.USER) {
          this.biodata = res?.data?.additional_detail;
          this.showForm = false;

        } else if (this.userType === UserTypes.VERIFIER) {
          if (res?.data?.institution_detail) {
            this.bioDataForm.patchValue({
              address: res?.data?.institution_detail?.address,
              description: res?.data?.institution_detail?.description,
              email_public: res?.data?.institution_detail?.allow_public_use_of_email
            })
          }
        }
      })
      .catch((err: any) => {
        this.showForm = false;
        this.fetching = false;
        console.warn(err);
      });
  }

  checkFormValidity() {
    if (!this.bioDataForm.valid) {
      // this.bioDataForm.controls.nin.markAsDirty();
      this.bioDataForm.controls.address.markAsDirty();
      this.bioDataForm.controls.address_duration.markAsDirty();
      return;
    }
  }

  showEditForm() {

    this.bioDataForm.patchValue({
      address: this.biodata?.address,
      address_duration: this.biodata?.address_duration,
      former_name: this.biodata?.former_name,
    });
    this.showForm = true;
  }

  hideEditForm() {
    this.showForm = false;
  }

  submitBioDataForm() {
    this.loading = true;
    let body: any;
    this.checkFormValidity();

    if (this.userType === UserTypes.USER) {
      body = {
        address: this.address,
        address_duration: this.address_duration,
        former_name: this.former_name
      }
      this.profileService
        .updateAdditionalInfo(body)
        .then((res: any) => {
          if (res?.status == ResponseStatus.FAILED) {
            this.notify.info("", res?.message);
            return;
          }

          this.loading = false;
          this.notify.success("", res.message);
          this.detailsUpdated = true;
          this.getBioData();
        })
        .catch((err) => {
          this.loading = false;
          console.warn(err);
        });
    } else if (this.userType === UserTypes.VERIFIER) {
      body = {
        user_id: this.user_id,
        address: this.address,
        description: this.description,
        allow_public_use_of_email: this.publicUseOfEmail
      }
      this.profileService
        .updateInsitutionBiodata(body)
        .then((res: any) => {
          if (res?.status == ResponseStatus.FAILED) {
            this.loading = false;
            this.notify.info("", res?.message);
            return;
          }

          this.loading = false;
          this.notify.success("", res.message);
          this.getBioData();
        })
        .catch((err) => {
          this.loading = false;
          console.warn(err);
        });
    }


  }


}
